import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    dailyData: Array,
    monthlyData: Array,
    currency: String
  }

  connect() {
    this.currentView = "daily"
    this.chart = null
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  switchToDaily(event) {
    event.preventDefault()
    this.currentView = "daily"
    this.updateButtonStates()
    this.renderChart()
  }

  switchToMonthly(event) {
    event.preventDefault()
    this.currentView = "monthly"
    this.updateButtonStates()
    this.renderChart()
  }

  updateButtonStates() {
    const dailyBtn = this.element.querySelector('[data-view="daily"]')
    const monthlyBtn = this.element.querySelector('[data-view="monthly"]')

    const activeClass = "bg-white text-teal-600 dark:bg-gray-700 dark:text-teal-400"
    const inactiveClass = "bg-gray-50 text-gray-500 dark:bg-gray-800 dark:text-gray-400"

    if (this.currentView === "daily") {
      dailyBtn.className = dailyBtn.className.replace(inactiveClass, activeClass)
      monthlyBtn.className = monthlyBtn.className.replace(activeClass, inactiveClass)
    } else {
      monthlyBtn.className = monthlyBtn.className.replace(inactiveClass, activeClass)
      dailyBtn.className = dailyBtn.className.replace(activeClass, inactiveClass)
    }
  }

  renderChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const data = this.currentView === "daily" ? this.dailyDataValue : this.monthlyDataValue
    const categories = data.map(d => d.label)
    const incomeData = data.map(d => d.income)
    const profitData = data.map(d => d.profit)
    const currencySymbols = {
      USD: "$", EUR: "€", UAH: "₴", GBP: "£", JPY: "¥", PLN: "zł", CAD: "C$", AUD: "A$"
    }
    const currency = currencySymbols[this.currencyValue] || this.currencyValue

    const options = {
      chart: {
        type: "area",
        height: 200,
        fontFamily: "Inter, sans-serif",
        toolbar: { show: false },
        zoom: { enabled: false }
      },
      series: [
        { name: "Income", data: incomeData, color: "#3B82F6" },
        { name: "Profit", data: profitData, color: "#10B981" }
      ],
      xaxis: {
        categories: categories,
        labels: {
          style: { colors: "#9CA3AF", fontSize: "11px" },
          rotate: -45,
          rotateAlways: this.currentView === "daily" && categories.length > 15
        },
        axisBorder: { show: false },
        axisTicks: { show: false }
      },
      yaxis: {
        labels: {
          style: { colors: "#9CA3AF", fontSize: "11px" },
          formatter: (value) => `${currency} ${value.toFixed(0)}`
        }
      },
      fill: {
        type: "gradient",
        gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1, stops: [0, 100] }
      },
      stroke: { curve: "smooth", width: 2 },
      dataLabels: { enabled: false },
      legend: {
        position: "top",
        horizontalAlign: "right",
        labels: { colors: "#9CA3AF" }
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: { formatter: (value) => `${currency} ${value.toFixed(2)}` }
      },
      grid: {
        borderColor: "#374151",
        strokeDashArray: 4,
        padding: { left: 10, right: 10, bottom: -10 }
      }
    }

    const chartElement = this.element.querySelector("#orders-chart")
    this.chart = new ApexCharts(chartElement, options)
    this.chart.render()
  }
}
